import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../../../../../../global/default-button/default-button';
import OECheckbox from '../../../../../../../../global/oe-checkbox/oe-checkbox';
import { AttributeValue } from '../../../../../../../../../api/attributes.dao';
import { useCollapsibleGrid } from './use-collapsible-grid';

type Props = {
    values: AttributeValue[];
    expanded: boolean;
    isSelected: (value: AttributeValue) => boolean;
    onToggle: (value: AttributeValue) => void;
    onToggleExpanded: () => void;
};

export const SelectValuePicker: React.FC<Props> = observer(({
    values,
    isSelected,
    onToggle,
    expanded,
    onToggleExpanded
}) => {
    const [stableValues] = useState(() => values);
    const {
        wrapperRef,
        gridRef,
        visibleValues,
        wrapperStyle,
        needsCollapse
    } = useCollapsibleGrid<AttributeValue>(stableValues, expanded);

    const showViewMore = needsCollapse && !expanded;
    const showViewLess = needsCollapse && expanded;

    return (
        <>
            <div ref={wrapperRef} style={wrapperStyle}>
                <div ref={gridRef} className='module-attribute__values-grid'>
                    {visibleValues.map(value => (
                        <OECheckbox
                            key={value.valueId}
                            checked={isSelected(value)}
                            onChange={() => onToggle(value)}
                            label={value.label}
                            classNames={!isSelected(value) ? 'module-attribute-value--unselected' : undefined}
                        />
                    ))}
                    {showViewMore && (
                        <DefaultButton
                            modifier='slim'
                            className='module-attribute__view-more-btn'
                            text={<FormattedMessage
                                id='oe.hubModule.viewMore'
                                defaultMessage='View More...'
                                description='Expand attribute values list'
                            />}
                            onClick={onToggleExpanded}
                        />
                    )}
                </div>
            </div>
            {showViewLess && (
                <DefaultButton
                    modifier='options'
                    className='module-attribute__view-toggle-btn'
                    text={<FormattedMessage
                        id='oe.hubModule.viewLess'
                        defaultMessage='View Less'
                        description='Collapse attribute values list'
                    />}
                    onClick={onToggleExpanded}
                />
            )}
        </>
    );
});
